import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { useSeverityBands } from './hooks/useSeverityBands';

// Auth components
import { AuthLayout, PrivateRoute } from './components/auth';
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from './pages/auth';

// Layout
import { MainLayout } from './components/layout';

// Main pages
import { DashboardPage } from './pages/DashboardPage';
import { CompaniesPage, TeamsPage, DepartmentsPage, UserManagementHubPage } from './pages/organizations';
import { RisksPage } from './pages/risks';
import { ContactsPage, ContactCreatePage, ContactEditPage } from './pages/contacts';
import { TasksPage } from './pages/tasks';
import { SettingsPage } from './pages/settings';
import AIReportsPage from './pages/ai-reports/AIReportsPage';
import AIReportViewPage from './pages/ai-reports/AIReportViewPage';

function App() {
  const { isAuthenticated } = useAuth();
  // Primes the severity bands from settings before the register renders a
  // badge. Harmless to call unauthenticated, the query just stays disabled.
  useSeverityBands(isAuthenticated);

  return (
    <div className="min-h-screen">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
        
        {/* Auth routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Route>

        {/* Protected routes */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/organizations/companies" element={<CompaniesPage />} />
          <Route path="/organizations/teams" element={<TeamsPage />} />
          <Route path="/organizations/departments" element={<DepartmentsPage />} />
          <Route path="/organizations/users" element={<UserManagementHubPage />} />
          <Route path="/risks" element={<RisksPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/contacts/new" element={<ContactCreatePage />} />
          <Route path="/contacts/:id/edit" element={<ContactEditPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/ai-reports" element={<AIReportsPage />} />
          <Route path="/ai-reports/:id" element={<AIReportViewPage />} />
          {/* Add more protected routes here */}
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;